export default ({ headerSize, title, testimonials }) => {
	return {
		headerSize,
		title,
		testimonials: getTestimonials(testimonials),
	};
};

const getTestimonials = (testimonials = []) => {
	return testimonials.map(({ gridClass = {}, ...testimonial }) => {
		let bootStrapClass = "";
		const tags = gridClass.tags;
		if (tags && tags.length) {
			tags.forEach(({ text }) => {
				bootStrapClass = `${bootStrapClass} ${text}`;
			});
		}
		return {
			...testimonial,
			gridClass: bootStrapClass,
		};
	});
};
